import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import api from "../../api/axiosInstance";
import Logo from "../../assets/logosnake.jpg";
import "./Createnewpassword.css";

import { resetPassword } from "../../api/adminAuthApi";

export default function CreateNewPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      // await api.post("/api/admin/auth/reset-password", {
      //   email,
      //   newPassword,
      // });

      const res = await resetPassword({ email, newPassword, confirmPassword });
      if (res?.success) {
        toast.success("Password reset successful");
        // navigate("/Layout/Dashboard");
        navigate("/Layout/Users");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="right-panel">
        <form className="login-card" onSubmit={handleSubmit}>
          <img className="logo" src={Logo} alt="logo" />
          <h2>Create New Password</h2>

          <div className="password-wrapper">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button type="button" onClick={() => setShowNew(!showNew)}>
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="password-wrapper">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button type="button" onClick={() => setShowConfirm(!showConfirm)}>
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
